export default "{\n    \"drawer\": {\n        \"expand\": \"Expandir navegación\",\n        \"collapse\": \"Contraer navegación\"\n    }\n}"